import { mapState } from "vuex";
export const comMixins = {
  data() {
    return {
      jumpPageList: [
        { label: "点单页", value: "tab1" },
        { label: "我的", value: "tab2" },
        { label: "会员页", value: "/pages/MemberInfo/MemberInfo" },
        { label: "次卡页", value: "/pagesMarketing/secondaryCard/scCenter" },
        { label: "我的优惠券", value: "/pages/cashCouponList/cashCouponList" },
        { label: "领取优惠券", value: "/pages/cashCouponBatchList/cashCouponBatchList" },
        {
          label: "砍价",
          value: "/pagesMarketing/marketing/marketingList?activityType=2",
        },
        {
          label: "团购",
          value: "/pagesMarketing/marketing/marketingList?activityType=1",
        },
        {
          label: "积分商城",
          value: "/pagesMarketing/integral/integral",
        },
        {
          label: "分销中心",
          value: "/packagePage2/distribution/disCenter",
        },
        {
          label: "商品列表",
          value: "goods",
        },
        {
          label: "购物车",
          value: "goodsCar",
        },
        {
          label: "服务",
          value: "goods-yy",
        },
        {
          label: "首页",
          value: "index",
        },
      ],
      predefineColors: [
        "rgb(246, 246, 246)",
        "rgb(255, 69, 0)",
        "rgb(255, 140, 0)",
        "rgb(255, 215, 0)",
        "rgb(144, 238, 144)",
        "rgb(0, 206, 209)",
        "rgb(30, 144, 255)",
        "rgb(199, 21, 133)",
        "rgb(255, 120, 0)",
        "rgb(250, 212, 0)",
        "rgb(0, 186, 189)",
      ],
      predefineColorsAlpha: [
        "rgb(246, 246, 246)",
        "rgb(255, 69, 0)",
        "rgb(255, 140, 0)",
        "rgb(255, 215, 0)",
        "rgb(144, 238, 144)",
        "rgb(0, 206, 209)",
        "rgb(30, 144, 255)",
        "rgb(199, 21, 133)",
        "rgba(255, 69, 0, 0.68)",
        "rgb(255, 120, 0)",
        "rgb(250, 212, 0)",
        "rgba(144, 240, 144, 0.5)",
        "rgb(0, 186, 189)",
        "rgba(31, 147, 255, 0.73)",
        "rgba(199, 21, 133, 0.46)",
      ],
    }
  },
  computed: {
    ...mapState({
      decorationShopType: (state) => state.decorationShopType,
    }),
  },
  watch: {
  },
  created() {
  },
  methods: {
  }
}
